import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridsterModule } from 'angular-gridster2';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatDialogModule } from '@angular/material/dialog';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { MaterialModule } from './sharedModule/materialModule';
import { AnonymousUserComponentModule } from './user/anonymousUser/anonymous-user.component.module';
import { NavigationHistoryComponent, NavigationHistoryAllDialog } from './navigation/navigation-history.component';
import { GoogleMapComponentModule } from './google/googleMap/google-map.component.module';
import { SignupLoginComponentModule } from './user/signupLogin/signup-login.component.module';
import { SocialFollowIconModule } from './socialObject/socialFollowIcon/social-follow-icon.module';
import { TerritoryCardModule } from './territoryCard/territory-card.module';
import { UtilityModule } from './utility/utility.module';

@NgModule({
	declarations: [
		NavigationHistoryComponent,
		NavigationHistoryAllDialog
	],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		GridsterModule,
		NgbModule,
		MatDialogModule,
		NgMultiSelectDropDownModule,
		MaterialModule,
		AnonymousUserComponentModule,
		GoogleMapComponentModule,
		SignupLoginComponentModule,
		SocialFollowIconModule,
		TerritoryCardModule,
		UtilityModule
	],
	exports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		GridsterModule,
		NgbModule,
		MatDialogModule,
		NgMultiSelectDropDownModule,
		MaterialModule,
		AnonymousUserComponentModule,
		GoogleMapComponentModule,
		NavigationHistoryComponent,
		NavigationHistoryAllDialog,
		SignupLoginComponentModule,
		SocialFollowIconModule,
		TerritoryCardModule,
		UtilityModule
	]
})
export class SharedModule { }
